import {SortDirection} from "../../model/common/SortDirection";

class Sort {
    // private field: string;
    // private direction: string;

    // static Asc = "ASC";
    // static Desc = "DESC";

    constructor(field: string, direction: SortDirection) {
        // this.field = field;
        // this.direction = direction;
    }

    static sortArrBy(arr: any[], field: string, direction: SortDirection) {
        const DirectionModifier = (direction === SortDirection.Asc) ? 1 : -1;
        arr.sort((a, b) => {
            if (a[field] > b[field])
                return 1 * DirectionModifier;
            else if (a[field] < b[field])
                return -1 * DirectionModifier;
            else
                return 0;
        });
    }

    private static getValueToSort(nameOrFn: string | ((obj: any) => string | number)): (obj: any) => string | number {
        return (typeof nameOrFn === 'string')
                ? (object) => {
                    const value = object[nameOrFn];
                    return (typeof value === 'string') ? value.toLowerCase() : value;
                }
                : (object) => {
                    const value = nameOrFn(object);
                    return (typeof value === 'string') ? value.toLowerCase() : value;
                };

    }

    static getSortFn(nameOrFn: string | ((obj: any) => string | number), direction: SortDirection, nameOrFn2?: string | ((obj: any) => string | number)) {
        const DirectionModifier = (direction === SortDirection.Asc) ? 1 : -1;
        const getValueToSort = Sort.getValueToSort(nameOrFn);
        return (a, b) => {
            {
                if (getValueToSort(a) > getValueToSort(b)) {
                    return 1 * DirectionModifier;
                } else if (getValueToSort(a) < getValueToSort(b)) {
                    return -1 * DirectionModifier;
                } else {
                    //secondary / tiebreaker sort
                    if (nameOrFn2) {
                        const getValueToSort2 = Sort.getValueToSort(nameOrFn2);
                        if (getValueToSort2(a) > getValueToSort2(b)) {
                            return 1 * DirectionModifier;
                        } else if (getValueToSort2(a) < getValueToSort2(b)) {
                            return -1 * DirectionModifier;
                        } else {
                            return 0;
                        }
                    } else {
                        return 0;
                    }
                }
            }
        };
    }

    // static getSortFn(nameOrFn: string | ((obj: any) => string | number), direction: SortDirection, nameOrFn2?: string | ((obj: any) => string | number)) {
    //     //const getValueToSort = (typeof nameOrFn === 'string') ? (object) => object[nameOrFn] : nameOrFn;
    //     // const getValueToSort = (typeof nameOrFn === 'string')
    //     //     ? (object) => {
    //     //         const value = object[nameOrFn];
    //     //         return (typeof value === 'string') ? value.toLowerCase() : value;
    //     //     }
    //     //     : (object) => {
    //     //         const value = nameOrFn(object);
    //     //         return (typeof value === 'string') ? value.toLowerCase() : value;
    //     //     };
    //     const DirectionModifier = (direction === SortDirection.Asc) ? 1 : -1;
    //     return (a, b) => {
    //         {
    //             if (getValueToSort(a) > getValueToSort(b)) {
    //                 return 1 * DirectionModifier;
    //             } else if (getValueToSort(a) < getValueToSort(b)) {
    //                 return -1 * DirectionModifier;
    //             } else {
    //                 //secondary / tiebreaker sort
    //                 if (nameOrFn2) {
    //                     const getValueToSort2 = (typeof nameOrFn2 === 'string') ? (object) => object[nameOrFn2] : nameOrFn2;
    //                     if (getValueToSort2(a) > getValueToSort2(b)) {
    //                         return 1 * DirectionModifier;
    //                     } else if (getValueToSort2(a) < getValueToSort2(b)) {
    //                         return -1 * DirectionModifier;
    //                     } else {
    //                         return 0;
    //                     }
    //                 } else {
    //                     return 0;
    //                 }
    //             }
    //         }
    //     };
    // }
}


//type SortDirection = "ASC" | "DESC"

export default Sort;